import {
  SIGNING_STATUSES,
  CUSTOM_ERROR_ANNOTATIONS,
  CUSTOM_ERROR_KEYS,
  CRYPTO_PLUGIN_IS_INACTIVE_LINK,
  CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_BEGIN,
  CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_END,
  CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION,
} from "../../constants";
import { DocumentsInfo, SigningTypes } from "../../types";
import { SIGNING_STATUSES_ANNOTATIONS } from "../constants";
import { getStatusAnnotationWithData } from "./get-status-annotation-with-data";

export const getStatusAnnotation = (
  status: string,
  signingType: SigningTypes,
  documentsTotalCount: number,
  signedDocumentsCount: number,
  validDocumentsCount: number,
  documentsInfo: DocumentsInfo,
  errorTitle?: string,
  errorKey?: string,
  error?: string
) => {
  const pluginIsInactiveAnnotations = (
    <>
      {CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_BEGIN}{" "}
      <a href={CRYPTO_PLUGIN_IS_INACTIVE_LINK} target="_blank">
        плагина
      </a>{" "}
      {CRYPTO_PLUGIN_IS_INACTIVE_ANNOTATION_END}
    </>
  );

  if (error === CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION) {
    return CANCEL_CONFIRM_WINDOW_BY_USER_ANNOTATION;
  }

  if (errorTitle) {
    if (errorKey === CUSTOM_ERROR_KEYS.CRYPTO_PLUGIN_IS_INACTIVE) {
      return pluginIsInactiveAnnotations;
    }

    return errorKey
      ? CUSTOM_ERROR_ANNOTATIONS[
          errorKey as Exclude<CUSTOM_ERROR_KEYS, "CRYPTO_PLUGIN_IS_INACTIVE">
        ]
      : error;
  }

  const defaultStatusAnnotation =
    SIGNING_STATUSES_ANNOTATIONS[signingType][
      status as keyof Pick<
        typeof SIGNING_STATUSES,
        | "SIGNING_STOPPED"
        | "CHECKING_SIGNING_POSSIBILITY"
        | "ERROR"
        | "SIGNING_COMPLETED"
      >
    ];

  if (
    status === SIGNING_STATUSES.IS_SIGNING ||
    status === SIGNING_STATUSES.READY_TO_BE_SIGNED ||
    (status === SIGNING_STATUSES.SIGNING_COMPLETED &&
      documentsTotalCount !== signedDocumentsCount)
  ) {
    return getStatusAnnotationWithData(
      status,
      signingType,
      documentsTotalCount,
      documentsInfo,
      signedDocumentsCount,
      validDocumentsCount
    );
  }

  return defaultStatusAnnotation;
};
